import { CorporateInvoiceVenuesData, InvoiceData } from "@/types";
import { BillingAdminzoneState } from "@/types/store/adminzone/billing";

export const state: BillingAdminzoneState = {
  invoices: [] as Array<InvoiceData>,
  all_invoices: [] as Array<InvoiceData>,
  allInvoicesCount: null,
  corporateInvoiceVenues: [] as Array<CorporateInvoiceVenuesData>
}
